<template class="pt-0">
  <div>
    <!--For production release comment entire div from line -4 to line no 8-->
    <div class="mb-5" v-if="showUATBar">
      <v-app-bar elevation="6" style="z-index:4 !important; position: fixed;" dense
        class="mx-0 mt-15 environment-banner" :class="environmentBannerClass" fixed>
        <v-app-bar-title class="environment-banner__content">
          <span class="environment-banner__icon">
            <v-icon x-small color="#1f2a37">mdi-information</v-icon>
          </span>
          <span>
            You are logged into the <strong>{{ envName }}</strong> environment
          </span>
        </v-app-bar-title>
      </v-app-bar>
    </div>
    <div class="mb-7">
      <!--Enable below line when it is the Production and comment the other line-->
      <!-- <v-app-bar elevation="2" style="z-index:1 !important; position: fixed;" dense class="mx-7 mt-13" fixed> -->
      <v-app-bar elevation="2" style="z-index:4 !important; position: fixed;" dense class="mx-7"
        v-bind:class="(!showUATBar) ? 'mt-13' : 'mt-1'" :fixed="!showUATBar">
        <v-app-bar-nav-icon text>
          <v-btn icon small @click="goToHome()" color="secondary">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </v-app-bar-nav-icon>
        <v-toolbar-title class="pa-0 mt-0">
          <v-breadcrumbs class="pa-0 ma-0">
            <template>
              <v-breadcrumbs-item class="primarytext--text" disabled>
                {{ mainPage }}
              </v-breadcrumbs-item>
              <v-breadcrumbs-item small v-if="backSlash"> / </v-breadcrumbs-item>
              <v-breadcrumbs-item v-if="backSlashParent" class="primarytext--text">
                <router-link active-class="active" :to="'/' + subPageUrl" exact>
                  <a class="nav-link primarytext--text">
                    {{ subPage }}
                  </a>
                </router-link>
              </v-breadcrumbs-item>
              <v-breadcrumbs-item class="primarytext--text" v-else-if="customPage">
                <router-link active-class="active" :to="'/' + customSubPageUrl" exact>
                  <a class="nav-link primarytext--text">
                    {{ customSubPage }}
                  </a>
                </router-link>
              </v-breadcrumbs-item>
              <v-breadcrumbs-item class="primarytext--text" v-else>
                <router-link active-class="active" :to="'/' + pageUrl" exact>
                  <a class="nav-link primarytext--text">
                    {{ subPage }}
                  </a>
                </router-link>
              </v-breadcrumbs-item>
              <v-breadcrumbs-item class="primarytext--text hidden-sm-and-down" small v-if="backSlashParent"> /
              </v-breadcrumbs-item>
              <v-breadcrumbs-item class="primarytext--text">
                <span class="nav-link primarytext--text">
                  {{ appPageName }}
                </span>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dense outlined class="mr-1 pa-0" @click="saveDataProp()" title="Save" v-if="printer"
          :disabled="disableSave" small>
          <v-icon color="green" dark small>mdi-content-save</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onClickShip" title="Ready To Ship"
          v-if="showReadyToShip">
          <v-icon color="primarytext">mdi mdi-truck</v-icon>
        </v-btn>
        <v-btn v-if="dropLPN" class="mr-1 px-1 pa-0" dense small outlined :title="lpnDrop" @click="onClickDropLPN"
          color="primarytext">
          <v-icon small>mdi-download-outline</v-icon> {{ lpnDrop }}
        </v-btn>
        <v-btn v-if="dropUSBLPN" class="mr-1 px-1 pa-0" dense small outlined :title="usbLPNDrop"
          @click="onClickUSBDropLPN" color="primarytext">
          <v-icon small>mdi-download-outline</v-icon> {{ usbLPNDrop }}
        </v-btn>
        <v-btn v-if="lpnStatus" class="mr-1 px-1 pa-0" :disabled="!lpnNum" dense small outlined :title="lpnText"
          @click="onClickShowLPN" color="primarytext">
          {{ lpnText }} <v-icon small></v-icon>
        </v-btn>
        <v-btn v-if="usbLPNStatus" class="mr-1 px-1 pa-0" :disabled="!usbLPNNum" dense small outlined
          :title="usbLPNText" @click="onClickShowUSBLPN" color="primarytext">
          {{ usbLPNText }} <span v-if="usbLPNQuantity !== 0">({{ usbLPNQuantity }})</span>
        </v-btn>
        <v-btn v-if="redirectTo" class="mr-1 px-1 pa-0" dense small outlined :title="title" color="primarytext"
          @click="redirectToPage">
          {{ title }} <v-icon small> mdi-arrow-right</v-icon>
        </v-btn>
        <v-btn v-if="savePart" class="mr-1 pa-0" dense small outlined title="Save" color="primarytext"
          @click="partSave()" :disabled="savePartDisable">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
        <v-btn v-if="showUpdate" class="mr-1 pa-0" dense small outlined title="Update" color="primarytext"
          @click="updateFunction()">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
        <v-btn v-if="showSave" class="mr-1 pa-0" dense small outlined title="Submit" color="primarytext"
          @click="submitFunction()">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
        <v-btn v-if="updateSO" class="mr-1 pa-0" dense small outlined title="Update" color="primarytext"
          @click="soUpdate()">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
        <v-btn v-if="showPartChange" @click="onClickChangePart" class="pa-0 my-0 float-left mr-1" dense small outlined
          title="Change Part Number" color="primarytext"> <v-icon small> mdi mdi-swap-horizontal </v-icon>
        </v-btn>
        <v-btn v-if="updatePart" class="mr-1 pa-0" dense small outlined title="Update" color="primarytext"
          @click="partUpdate()">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
        <v-btn v-if="saveRole" :disabled="disableSaveRole && pageUrl == 'app-role-edit'" class="mr-1 pa-0" dense small
          outlined title="Save" color="primarytext" @click="saveRoleDetails()">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
        <v-btn title="Download Printer Utility" @click="downloadUtilityProp()" v-if="printer" dense outlined
          class="mr-1 pa-0" small>
          <v-icon small color="primarytext">mdi-arrow-down-bold-circle-outline</v-icon>
        </v-btn>
        <v-btn dense small outlined class="mr-1 pa-0" @click="removeDataProp()" title="Remove Printer Details"
          v-if="printer">
          <v-icon color="red" small>mdi-close-circle</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="error" v-if="showPurgeUSB" title="Purge"
          @click="purgeUSBAsset()">
          <v-icon color="red" small>mdi-delete</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" v-if="showDocumentEdit" title="Edit Document"
          @click="documentEdit()">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="error" v-if="showDocumentDelete" title="Document Delete"
          @click="documentDelete()">
          <v-icon color="red" small>mdi-delete</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" v-if="showCountNewBin" title="Count New Bin"
          @click="countNewBin" :disabled="disableCountNewBin">
          <v-icon color="primarytext" small>mdi-abacus</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" v-if="showReconcileBin" title="Reconcile Bin"
          @click="reconcileBin" :disabled="disableReconcileBin">
          <v-icon color="primarytext" small>mdi-format-list-checks</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" v-if="showBinCounts" title="Bin Counts"
          @click="binCounts" :disabled="disableBinCounts">
          <v-icon color="primarytext" small>mdi-counter</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" v-if="showSessionCounts"
          title="Session Counts" @click="sessionCounts" :disabled="disableSessionCounts">
          <v-icon color="primarytext" small>mdi-web-refresh</v-icon>
        </v-btn>
        <!-- if show refresh is true then it will open refresh dialog box -->
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" v-if="showRefreshDialog && !addReset"
          @click="refreshDialog = true" title="Reset">
          <v-icon color="primarytext" small>mdi-refresh</v-icon>
        </v-btn>
        <!--Reset Draft  -->
        <v-btn class="mr-2 pa-2  f-bold hidden-sm-and-down" dense small outlined color="error"
          v-if="showRefreshDialog && addReset" @click="refreshDialog = true" title="Restart Draft">
          RESTART DRAFT
        </v-btn>
        <v-btn class="hidden-md-and-up mr-1" dense small outlined color="error" v-if="showRefreshDialog && addReset"
          @click="refreshDialog = true" title="Restart Draft">
          <v-icon small>mdi mdi-restart</v-icon>
        </v-btn>
        <!-- <v-btn class="mr-1" dense small outlined color="primary" v-if="showTechComment" @click="techCommentProp()"
          title="Tech Comment" :disabled="disableTechComment">
          <v-icon small>mdi-comment-account-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1" dense small outlined color="primary" v-if="showEcoInfo" @click="ecoInfoProp()"
          title="Eco Info" :disabled="disableEcoInfo">
          <v-icon small>mdi-information-slab-box-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1" dense small outlined color="primary" v-if="showMSRHistory" @click="msrHistoryProp()"
          title="MSR History" :disabled="disableMSRHistory">
          <v-icon small>mdi-timer-refresh-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1" dense small outlined color="primary" v-if="showCloseEngEval" @click="closeEngEvalProp()"
          title="Remove Tech Comments" :disabled="disableCloseEngEval">
          <v-icon small>mdi-delete</v-icon>
        </v-btn> -->
        <v-btn class=" mr-1" dense small outlined color="primary" v-if="refreshDetails" @click="resetFunctionProp"
          title="Refresh">
          <v-icon small>mdi mdi-restart</v-icon>
        </v-btn>
        <!-- If show Refresh dialog is false then refresh button will resresh -->
        <v-btn v-else-if="refresh && !showRefreshDialog && !addReset" icon small @click="resetFunctionProp()"
          title="Reset">
          <v-icon color="primarytext">mdi-refresh</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" v-else-if="refreshOutlined" title="Reset"
          @click="resetFunctionProp()">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon small @click="addFav()" title="Add To Favorites"
          v-if="!showAdd && !back && !receiveBack && !hideFav && !customBack">
          <v-icon color="secondary">mdi mdi-star-outline</v-icon>
        </v-btn>
        <v-btn icon small @click="addFav()" title="Remove From Favorites"
          v-if="showAdd && !back && !hideFav && !customBack && !receiveBack">
          <v-icon color="secondary">mdi-star</v-icon>
        </v-btn>
        <v-btn dense outlined class="mr-1 pa-0" small @click="onUserActionHistory()" title="User Action History"
          v-if="actionHistory">
          <v-icon color="primarytext" small>mdi-account-cog-outline</v-icon>
        </v-btn>
        <v-btn dense outlined class="mr-1 pa-0" small @click="onUserHistory()" title="User Login History"
          v-if="loginHistory">
          <v-icon color="primarytext" small>mdi mdi-account-clock-outline</v-icon>
        </v-btn>
        <v-menu v-if="soRevertToBackorder || forceAllocateOrder || clearShippingAudit"
          offset-y left transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-1 pa-0" dense small outlined color="error" v-bind="attrs" v-on="on" title="Order Actions"
              :disabled="disableOrderActions">
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-if="soRevertToBackorder" @click="onSORevertToBackorder()">
              <v-list-item-title>Revert To Backorder</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="forceAllocateOrder" @click="onForceAllocateOrder()">
              <v-list-item-title>Force Allocate Order</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="clearShippingAudit" @click="onClearShippingAudit()">
              <v-list-item-title>Clear Shipping Audit</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn dense outlined class="mr-1 pa-0" small @click="onSalesOrderHistory()" title="Sales Order History"
          v-if="soHistory">
          <v-icon color="primarytext" small>mdi mdi-clipboard-text-clock</v-icon>
        </v-btn>
        <v-btn dense outlined class="mr-1 pa-0" small @click="partialShipmentLineItem()" title="Partial Shipment"
          v-if="showPartialShipLineDetails">
          <v-icon color="primarytext" small>mdi-call-split</v-icon>
        </v-btn>
        <v-btn dense outlined class="mr-1 pa-0" small @click="onCickUndo()" title="Undo" v-if="showUndo">
          <v-icon color="primarytext" small>mdi mdi-undo</v-icon>
        </v-btn>
        <v-btn dense outlined class="mr-1 pa-0" small @click="onSalesOrderHistory()" title="Purchase Order History"
          v-if="poHistory">
          <v-icon color="primarytext" small>mdi mdi-clipboard-text-clock</v-icon>
        </v-btn>
        <v-btn dense outlined class="mr-1 pa-0" small @click="onAssignedUserList()" title="Assigned Users"
          v-if="assignedUserList">
          <v-icon color="primarytext" small>mdi mdi-account-multiple-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onEditClickRedirect" title="Edit"
          v-if="showEditRedirect">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onClickPrepare" title="Prepare"
          v-if="showScopeAction" :disabled="!enablePrepare">
          <v-icon small>mdi mdi-note-edit-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onClickStartCount" title="Start Count"
          v-if="showScopeAction" :disabled="!enableStartCount">
          <v-icon small>mdi mdi-play-circle-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onClickReconcile" title="Reconcile"
          v-if="showScopeAction" :disabled="!enableReconcile">
          <v-icon small>mdi mdi-note-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onClickAbortCount" title="Stop Count"
          v-if="showScopeAction" :disabled="!enableStopCount">
          <v-icon small>mdi mdi-stop-circle-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="secondary" @click="onAddBookmark" title="Add Bookmark"
          v-if="!bookmark && showBookMark">
          <v-icon small>mdi mdi-bookmark-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onPDFPrint" title="PDF Print"
          v-if="showPDFPrint">
          <v-icon small>mdi-printer</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="secondary" @click="onRemoveBookmark"
          title="Remove BookMark" v-if="bookmark && showBookMark">
          <v-icon color="secondary">mdi mdi-bookmark</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="#D8A000" @click="onSOHold" title="Hold Order"
          v-if="!hold && showHold">
          <v-icon color="#D8A000" small>mdi-play-pause</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="error" @click="onShipmentHold" title="Shipment Hold"
          v-if="showShipmentHold">
          <v-icon color="error" small>mdi-truck-alert-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onSORelease" title="Release Order"
          v-if="hold && showHold">
          <v-icon color="primarytext">mdi mdi-play-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onClickStartSourcing()"
          title="Start Sourcing" v-if="showStartSourcing">
          <v-icon small>mdi mdi-play-circle-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="primarytext" @click="onClickStopSourcing()"
          title="Stop Sourcing" v-if="showStopSourcing">
          <v-icon small>mdi mdi-stop-circle-outline</v-icon>
        </v-btn>
        <v-btn class="mr-1 pa-0" dense small outlined color="error" @click="onClickDelete"
          :title="showHold ? 'Cancel' : 'Delete'" v-if="showDelete">
          <v-icon v-if="showHold" small>mdi mdi-cancel</v-icon>
          <v-icon v-else small>mdi-delete</v-icon>
        </v-btn>
        <div v-if="receiveLabelSwitch" class="pt-5 px-2">
          <v-switch class="ma-1 d-inline-block" @change="onChangeLabel" dense v-model="labelValue"
            :label="`${labelSwitchText || 'Labels'} ${labelValue ? 'On' : 'Off'}`" inset color="primarytext"
            :disabled="disableLabelsOn"></v-switch>
        </div>
        <v-btn title="Route to Discreancy" class="mr-1 pa-1" dense small outlined color="error"
          v-if="receiveRouteDiscrepancy" @click="onClickRouteDiscrepancy">
          <v-icon> mdi mdi-alert-outline </v-icon>
        </v-btn>
        <v-btn title="Quick Verification" class="mr-1 pa-1" dense small outlined color="primarytext"
          v-if="receiveQuickVerification" @click="onClickReceiveVerification">
          <v-icon> mdi mdi-file-document</v-icon>
        </v-btn>
        <v-btn :disabled="disableStaging" class="mr-1 pa-1" dense small outlined color="primarytext"
          v-if="showReceiveStaging" @click="onClickReceiveStaging">
          Staging Location:{{ showReceiveStagingVal }}
          <v-icon small color="primarytext">mdi mdi-cog-outline</v-icon>
        </v-btn>
        <v-btn v-if="showReceiveLPN" @click="onClickReceiveLPN" class="mr-1 pa-1" dense small outlined
          color="primarytext">
          LPN:{{ showLpnVal }}
          <v-icon color="primarytext" small class="float-right">mdi mdi-cog-outline</v-icon>
        </v-btn>
        <v-btn dense outlined class="mr-1 pa-0" small @click="onEditClick()" title="Edit" v-if="showEdit">
          <v-icon color="primarytext" small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn v-if="showAddDocument" class="mr-1 pa-0" dense small outlined title="Add Document" color="primarytext"
          @click="onAddDocument()">
          <v-icon small> mdi-plus-circle </v-icon>
        </v-btn>
        <v-btn v-if="back" class="mr-1 pa-0" dense small outlined title="Back" color="primarytext"
          @click="$router.go(-1)">
          <v-icon small> mdi-arrow-left </v-icon>
        </v-btn>
        <v-btn v-if="customBack" class="mr-1 pa-0" dense small outlined title="Back" color="primarytext"
          @click="customRedirect">
          <v-icon small> mdi-arrow-left </v-icon>
        </v-btn>
        <v-btn v-if="documentBack" class="mr-1 pa-0" dense small outlined title="Back" color="primarytext"
          @click="documentRedirect">
          <v-icon small> mdi-arrow-left </v-icon>
        </v-btn>
        <v-btn v-if="pageLvlBack" class="mr-1 pa-0" dense small outlined title="Back" color="primarytext"
          @click="pageBack()">
          <v-icon small> mdi-arrow-left </v-icon>
        </v-btn>
        <v-btn v-if="showReceiveReset" class="mr-1 pa-0" dense small outlined color="primarytext"
          @click="onClickReceiveReset('reset')" title="Reset">
          <v-icon small color="primary">mdi mdi-sync</v-icon>
        </v-btn>
        <v-btn v-if="receiveBack" @click="onClickReceiveReset('back')" class="mr-1 pa-0" dense small outlined
          color="primarytext" title="Back">
          <v-icon small color="primary"> mdi-arrow-left </v-icon>
        </v-btn>
        <v-btn icon small @click="onClickReportIssue" title="Report Issue">
          <v-icon color="primary">mdi mdi-comment-alert</v-icon>
        </v-btn>
        <!-- hamburger -->
        <span v-if="showHamBuger" class="hidden-md-and-up">
          <v-menu offset-y :rounded="1" :close-on-content-click="false" :nudge-width="100">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon elevation="0" class="pa-0 ma-0" v-bind="attrs" v-on="on">
                <v-icon color="secondary">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list v-if="showActionsList" :key="i" class="web-list py-3 float-right" width="150">
              <v-row>
                <v-col offset-sm="3" cols="12" sm="12" md="12" lg="6" class="px-5 py-1" v-for="item in showActionsList"
                  :key="item" link>
                  <v-text @click="clickEvents(item.Id)" class="float-left">
                    <v-icon color="secondary" small v-text="item?.Icon"></v-icon>&nbsp;<v-text
                      class="font-weight-bold secondary--text">
                      {{ item.FriendlyName }}</v-text>
                  </v-text>
                </v-col>
              </v-row>
            </v-list>
          </v-menu>
        </span>
      </v-app-bar>
      <!-- Refresh Dialog -->
      <v-row justify="center">
        <v-col sm="12" md="6" lg="6">
          <v-dialog v-model="refreshDialog" max-width="500px">
            <v-card class="add-menu containerbox">
              <v-card-title class="text-subtitle-1 mx-auto">Are you sure you want to reset this item?</v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <template>
                  <v-btn color="primarytext" outlined dense class="ma-2 btn-style" elevation="1"
                    @click="resetFunctionProp">OK</v-btn>
                  <v-btn color="secondary" outlined dense class="ma-2 btn-style" elevation="1"
                    @click=" refreshDialog = false">Cancel
                  </v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <FeedbackForm v-if="showFeedbackForm" :showFeedbackForm="showFeedbackForm" :pageName="page" :url="url"
        @closeFeedback="closeFeedbackDialog" />
      <ViewLPNDetails v-if="showLPNDetails" :showLPNDetails="showLPNDetails" @closeLPN="closeLPNDialog"
        :lpnNum="lpnNum" />
      <ViewUSBLPNDetails v-if="showUSBLPNDetails" :showUSBLPNDetails="showUSBLPNDetails" @closeLPN="closeUSBLPNDialog"
        :usbLPNNum="usbLPNNum" />
    </div>
  </div>
</template>
<script>
import { bus } from '../../main'
import { APPCODE } from '../utility/js/constants-utility';
import FeedbackForm from './feedback-comp.vue';
import ViewLPNDetails from "./lpn-details-comp.vue";
import ViewUSBLPNDetails from "./usb-lpn-details-comp.vue";
export default {
  name: 'breadcrumbComp',
  props: {
    hideFav: Boolean,
    mainPage: String,
    subPage: String,
    pageName: String,
    addReset: Boolean,
    showHamBuger: Boolean,
    refresh: Boolean,
    appPageName: String,
    showUpdate: Boolean,
    pageUrl: String,
    refreshDetails: Boolean,
    showTechComment: Boolean,
    showEcoInfo: Boolean,
    showMSRHistory: Boolean,
    showCloseEngEval: Boolean,
    receiveRouteDiscrepancy: Boolean,
    disableStaging: Boolean,
    updateSO: Boolean,
    customSubPageUrl: String,
    customSubPage: String,
    customPage: String,
    receiveBack: Boolean,
    redirectTo: Boolean,
    showReceiveReset: Boolean,
    title: String,
    poHistory: Boolean,
    receiveQuickVerification: Boolean,
    receiveLabelSwitch: Boolean,
    customUrl: String,
    showAdd: Boolean,
    showRemove: Boolean,
    printer: Boolean,
    saveRole: Boolean,
    backSlash: Boolean,
    resetFunction: Function,
    saveData: Function,
    downloadUtility: Function,
    removeData: Function,
    backSlashParent: String,
    showPartChange: Boolean,
    subPageUrl: String,
    showDelete: Boolean,
    showRefreshDialog: Boolean,
    refreshOutlined: Boolean,
    showPurgeUSB: Boolean,
    showDocumentDelete: Boolean,
    showDocumentEdit: Boolean,
    showEdit: Boolean,
    showAddDocument: Boolean,
    back: Boolean,
    customBack: Boolean,
    documentBack: Boolean,
    pageLvlBack: Boolean,
    disableSave: Boolean,
    showEditRedirect: Boolean,
    redirectPage: Function,
    bookmark: Boolean,
    addBookmark: Function,
    removeBookmark: Function,
    showBookMark: Boolean,
    showPDFPrint: Boolean,
    showSave: Boolean,
    showUndo: Boolean,
    showScopeAction: Boolean,
    enablePrepare: Boolean,
    enableStopCount: Boolean,
    enableReconcile: Boolean,
    enableStartCount: Boolean,
    showStartSourcing: Boolean,
    showStopSourcing: Boolean,
    showHold: Boolean,
    showShipmentHold: Boolean,
    hold: Boolean,
    soHold: Function,
    loginHistory: Boolean,
    actionHistory: Boolean,
    soHistory: Boolean,
    soCallLogs: Boolean,
    soRevertToBackorder: Boolean,
    forceAllocateOrder: Boolean,
    clearShippingAudit: Boolean,
    disableOrderActions: Boolean,
    showPartialShipLineDetails: Boolean,
    assignedUserList: Boolean,
    userListAssigned: Function,
    savePart: Boolean,
    savePartDisable: Boolean,
    updatePart: Boolean,
    changePartNum: Function,
    showActionsList: Array,
    saveRoleDetail: Function,
    updateRoleDetail: Function,
    lpnStatus: Boolean,
    usbLPNStatus: Boolean,
    dropLPN: Boolean,
    dropUSBLPN: Boolean,
    lpnText: String,
    usbLPNText: String,
    usbLPNQuantity: String,
    lpnDrop: String,
    usbLPNDrop: String,
    lpnNum: Number,
    usbLPNNum: Number,
    showReadyToShip: Boolean,
    showCountNewBin: Boolean,
    showReconcileBin: Boolean,
    showBinCounts: Boolean,
    showSessionCounts: Boolean,
    disableCountNewBin: Boolean,
    disableReconcileBin: Boolean,
    disableBinCounts: Boolean,
    disableSessionCounts: Boolean,
    showReceiveLPN: Boolean,
    showReceiveStaging: Boolean,
    showReceiveStagingVal: String,
    showLpnVal: String,
    disableTechComment: Boolean,
    disableEcoInfo: Boolean,
    disableMSRHistory: Boolean,
    disableCloseEngEval: Boolean,
    labelValue: Boolean,
    labelSwitchText: String,
  },
  data: () => ({
    refreshDialog: false,
    bookmark: false,
    hold: false,
    disableSaveRole: true,
    showFeedbackForm: false,
    showLPNDetails: false,
    showUSBLPNDetails: false,
    disableLabelsOn: false,
    showUATBar: false,
    envName: "",
    page: "",
    url: "",
  }),
  computed: {
    environmentBannerClass() {
      return this.envName === "IT" ? "environment-banner--it" : "environment-banner--uat";
    },
  },
  created() {
    bus.$on('bookmark', (data) => {
      this.bookmark = data.bookmark
    }),
      bus.$on('hold', (data) => {
        this.hold = data
      })
  },
  mounted() {
    const code = APPCODE?.toLowerCase() || "";
    if (code.includes("localhost") || code.includes("rlpwebit") || code.includes("azurewebsi") || code.includes("it.rlpweb.com")) {
      this.showUATBar = true;
      this.envName = "IT";
    }
    else if (code.includes("uat")) {
      this.showUATBar = true;
      this.envName = "UAT";
    }
    else if (code.includes("rlpweb.com") || code.includes("rlpwebpp")) {
      this.showUATBar = false;
      this.envName = "";
    }
    else {
      this.showUATBar = false;
      this.envName = "";
    }
  },
  beforeUpdate() {
    this.setFeedbackPage()
  },
  methods: {
    clickEvents(item) {
      switch (item) {
        case "SO-BookMark":
          this.$emit('addBookmark');
          break;
        case "SO-BookMark-Remove":
          this.$emit('removeBookmark');
          break;
        case "SO-Hold":
          this.onSOHold();
          break;
        case "SO-ShipmentHold":
          this.onShipmentHold();
          break;
        case "SO-Release":
          this.onSORelease();
          break;
        case "SO-Delete":
          this.onClickDelete();
          break;
        case "SO-Reset":
          this.refreshDialog = true;
          break;
        case "PO-Reset":
          this.refreshDialog = true;
          break;
        case "SO-Edit":
          this.$emit('redirectPage');
          break;
        case "PO-Edit":
          this.$emit('redirectPage');
          break;
        case "SO-History":
          this.$emit('salesOrderHistoryClicked');
          break;
        case "PO-History":
          this.$emit('salesOrderHistoryClicked');
          break;
        case "PO-BookMark":
          this.$emit('addBookmark');
          break;
        case "PO-BookMark-Remove":
          this.$emit('removeBookmark');
          break;
        case "PO-Hold":
          this.onSOHold();
          break;
        case "PO-Release":
          this.onSORelease();
          break;
        case "PO-Delete":
          this.onClickDelete();
          break;
        default:
          break;
      }
    },
    resetFunctionProp() {
      this.resetFunction();
      this.refreshDialog = false
    },
    techCommentProp() {
      this.$emit("techCommentClick");
    },
    ecoInfoProp() {
      this.$emit("ecoInfoClick");
    },
    msrHistoryProp() {
      this.$emit("msrHistoryClick");
    },
    closeEngEvalProp() {
      this.$emit("closeEngEvalClick");
    },
    goToHome() {
      this.$router.push('/home');
    },
    customRedirect() {
      this.$router.push(this.customUrl);
    },
    documentRedirect() {
      this.$emit("documentRedirect");
    },
    pageBack() {
      this.$emit("pageLvlBack");
    },
    soUpdate() {
      this.$emit("updateSODetails");
    },
    onClickReceiveStaging() {
      this.$emit("onClickReceiveStagingFunction")
    },
    updateFunction() {
      this.$emit("updateFunction");
    },
    submitFunction() {
      this.$emit("submitFunction");
    },
    partSave() {
      this.$emit("savePartDetails");
    },
    partUpdate() {
      this.$emit("updatePartDetails");
    },
    onClickChangePart() {
      this.$emit("changePartNum");
    },
    purgeUSBAsset() {
      this.$emit("purgeUSBAsset");
    },
    documentDelete() {
      this.$emit("documentDelete");
    },
    documentEdit() {
      this.$emit("documentEdit");
    },
    saveRoleDetails() {
      this.$emit("saveRoleDetail");
    },
    onClickPrepare() {
      this.$emit("onClickPrepare");
    },
    onClickAbortCount() {
      this.$emit("onClickAbortCount");
    },
    onClickStartCount() {
      this.$emit("onClickStartCount");
    },
    onClickStartSourcing() {
      this.$emit("onClickStartSourcing");
    },
    onClickStopSourcing() {
      this.$emit("onClickStopSourcing");
    },
    onChangeLabel() {
      this.$emit("onChangeLabelFunction", this.labelValue);
    },
    onClickReconcile() {
      this.$emit("onClickReconcile");
    },
    onClickReceiveReset(loc) {
      this.$emit("onClickReceiveResetFunction", loc);
    },
    onClickReceiveVerification() {
      this.$emit("receiveQuickVerificationFunction");
    },
    saveDataProp() {
      this.saveData();
    },
    downloadUtilityProp() {
      this.downloadUtility();
    },
    addFav() {
      this.$emit('addFav');
    },
    removeDataProp() {
      this.removeData();
    },
    onEditClick() {
      this.disableSaveRole = false;
      this.$emit('editClicked');
    },
    onAddDocument() {
      this.$emit('addDocumentClicked');
    },
    onClickDelete() {
      this.$emit('deleteClicked');
    },
    onEditClickRedirect() {
      this.$emit('redirectPage');
    },
    onAddBookmark() {
      this.$emit('addBookmark');
    },
    onPDFPrint() {
      this.$emit('pdfPrintClicked');
    },
    onRemoveBookmark() {
      this.$emit('removeBookmark');
    },
    onSOHold() {
      this.$emit('hold');
    },
    onShipmentHold() {
      this.$emit('shipmentHold');
    },
    onSORelease() {
      this.$emit('release');
    },
    onUserHistory() {
      this.$emit('userHistoryClicked');
    },
    onUserActionHistory() {
      this.$emit('userActionHistoryClicked');
    },
    onSalesOrderHistory() {
      this.$emit('salesOrderHistoryClicked');
    },
    onSalesOrderCallLogs() {
      this.$emit('onSalesOrderCallLogsClicked');
    },
    onSORevertToBackorder() {
      this.$emit('soRevertToBackorderClicked');
    },
    onForceAllocateOrder() {
      this.$emit('forceAllocateOrderClicked');
    },
    onClearShippingAudit() {
      this.$emit('clearShippingAuditClicked');
    },
    partialShipmentLineItem() {
      this.$emit('partialShipmentLineItem');
    },
    onAssignedUserList() {
      this.$emit('assignedUserClicked');
    },
    onClickShip() {
      this.$emit('readyToShip');
    },
    onClickReportIssue() {
      this.showFeedbackForm = true
    },
    onClickShowLPN() {
      this.showLPNDetails = true
    },
    onClickShowUSBLPN() {
      this.showUSBLPNDetails = true;
    },
    onClickDropLPN() {
      this.$emit('onClickDropLPN');
    },
    onClickUSBDropLPN() {
      this.$emit('onClickUSBDropLPN');
    },
    onCickUndo() {
      this.$emit("onClickUndo")
    },
    closeFeedbackDialog() {
      this.showFeedbackForm = false
    },
    closeLPNDialog() {
      this.showLPNDetails = false
    },
    closeUSBLPNDialog() {
      this.showUSBLPNDetails = false;
    },
    countNewBin() {
      this.$emit("onClickCountNewBin");
    },
    reconcileBin() {
      this.$emit("onClickReconcileBin");
    },
    binCounts() {
      this.$emit("onClickBinCounts");
    },
    onClickReceiveLPN() {
      this.$emit("onClickReceiveLPNFunction");
    },
    sessionCounts() {
      this.$emit("onClickSessionCounts");
    },
    onClickRouteDiscrepancy() {
      this.$emit("onClickRouteDiscrepancyFunction");
    },
    setFeedbackPage() {
      if (this.customPage) {
        this.page = this.customSubPage,
          this.url = this.customSubPageUrl
      }
      else if (this.backSlashParent) {
        this.page = this.appPageName
        this.url = this.pageUrl
      }
      else {
        this.page = this.subPage
        this.url = this.pageUrl
      }
    },
    redirectToPage() {
      if (this.title == "Redirect To Put Away") {
        this.$router.push("/put-away");
      }
      else {
        this.$router.push("/move");
      }
    }
  },
  components: {
    FeedbackForm,
    ViewLPNDetails,
    ViewUSBLPNDetails
  },
};
</script>
<style scoped>
.environment-banner {
  color: #1f2a37 !important;
  height: 32px !important;
  min-height: 32px !important;
  overflow: hidden;
}

.environment-banner--it {
  background: linear-gradient(90deg, #ffe0b5 0%, #ffc980 50%, #ffe0b5 100%) !important;
  box-shadow: 0 4px 14px rgba(219, 132, 23, 0.22) !important;
}

.environment-banner--uat {
  background: linear-gradient(90deg, #c9f6d8 0%, #98e9b4 50%, #c9f6d8 100%) !important;
  box-shadow: 0 4px 14px rgba(39, 156, 82, 0.2) !important;
}

.environment-banner::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.28), rgba(255, 255, 255, 0) 22%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0) 78%, rgba(255, 255, 255, 0.28)),
    repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.22) 0, rgba(255, 255, 255, 0.22) 1px, transparent 1px, transparent 18px);
  opacity: 0.42;
}

.environment-banner__content {
  align-items: center;
  color: #1f2a37;
  display: flex;
  font-size: 13px !important;
  font-weight: 500;
  gap: 8px;
  height: 32px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 0;
  padding: 0;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 1;
}

.environment-banner__icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.46);
  border: 1px solid rgba(31, 42, 55, 0.14);
  border-radius: 50%;
  display: inline-flex;
  flex: 0 0 16px;
  height: 16px;
  justify-content: center;
  width: 16px;
}

.environment-banner__content strong {
  font-weight: 700;
}

::v-deep .environment-banner .v-toolbar__content {
  align-items: center;
  height: 32px !important;
  justify-content: center;
  min-height: 32px;
  padding-left: 16px;
  padding-right: 16px;
}

@media (max-width: 600px) {
  .environment-banner__content {
    font-size: 13px !important;
    gap: 6px;
  }
}
</style>
